(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["matasana-barra"] && !Shopify.designMode) return;
  try {
    
  class MtsBarraCompra extends HTMLElement {
    connectedCallback() {
      this.removeAttribute('hidden');
      this.subir = this.querySelector('[data-mts-subir]');
      if (this.subir) {
        this.subir.addEventListener('click', () => {
          const caja = document.querySelector('form[action*="/cart/add"]:not(.mts-barra__form)');
          (caja || document.body).scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      // La barra aparece cuando la caja de compra de arriba sale de pantalla.
      // Si no la encuentra (plantilla distinta), cae a un umbral de scroll.
      const ancla = document.querySelector('form[action*="/cart/add"]:not(.mts-barra__form)');
      if (ancla && 'IntersectionObserver' in window) {
        this.observador = new IntersectionObserver(
          ([entrada]) => this.mostrar(!entrada.isIntersecting && entrada.boundingClientRect.top < 0),
          { threshold: 0 }
        );
        this.observador.observe(ancla);
      } else {
        this.alRodar = () => this.mostrar(window.scrollY > window.innerHeight);
        window.addEventListener('scroll', this.alRodar, { passive: true });
        this.alRodar();
      }
    }

    disconnectedCallback() {
      if (this.observador) this.observador.disconnect();
      if (this.alRodar) window.removeEventListener('scroll', this.alRodar);
    }

    mostrar(visible) {
      this.dataset.visible = visible ? 'true' : 'false';
    }
  }

  if (!customElements.get('mts-barra-compra')) {
    customElements.define('mts-barra-compra', MtsBarraCompra);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matasana-bestsellers"] && !Shopify.designMode) return;
  try {
    
  // Cintas que se desplazan solas. Van y vuelven, se pausan al tocarlas o al
  // pasar el cursor, y respetan la preferencia de menos movimiento del sistema.
  function mtsCintaAuto(cinta) {
    if (cinta.dataset.autoListo) return;
    cinta.dataset.autoListo = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var vel = parseFloat(cinta.dataset.bestVel || '28');
    var dir = 1, pausa = false, espera = 0, ultimo = null;
    // Acumulador propio: el navegador redondea scrollLeft y un avance de
    // menos de 1 px por cuadro se perdería en cada asignación.
    var pos = cinta.scrollLeft;
    cinta.addEventListener('scroll', function () {
      if (Math.abs(cinta.scrollLeft - pos) > 2) pos = cinta.scrollLeft;
    }, {passive: true});
    function reanudar() { espera = 1600; pausa = false; }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      cinta.addEventListener(ev, function () { pausa = true; espera = 0; }, {passive: true});
    });
    ['pointerup', 'touchend', 'pointercancel'].forEach(function (ev) {
      cinta.addEventListener(ev, reanudar, {passive: true});
    });
    cinta.addEventListener('mouseenter', function () { pausa = true; espera = 0; });
    cinta.addEventListener('mouseleave', reanudar);
    function paso(t) {
      if (ultimo === null) ultimo = t;
      var dt = Math.min((t - ultimo) / 1000, 0.05);
      ultimo = t;
      var max = cinta.scrollWidth - cinta.clientWidth;
      if (espera > 0) { espera -= dt * 1000; if (espera <= 0) espera = 0; }
      var visible = cinta.getBoundingClientRect().bottom > 0 && cinta.getBoundingClientRect().top < window.innerHeight;
      if (!pausa && espera === 0 && visible && max > 4) {
        pos += dir * vel * dt;
        if (pos >= max) { pos = max; dir = -1; espera = 1200; }
        if (pos <= 0) { pos = 0; dir = 1; espera = 1200; }
        cinta.scrollLeft = pos;
      }
      requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }
  document.querySelectorAll('[data-best-auto]').forEach(mtsCintaAuto);

  document.querySelectorAll('[data-best-seccion]').forEach(function (seccion) {
    if (seccion.dataset.listo) return;
    seccion.dataset.listo = '1';
    seccion.querySelectorAll('[data-best-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.dataset.bestTab;
        seccion.querySelectorAll('[data-best-tab]').forEach(function (t) {
          t.setAttribute('aria-selected', String(t === tab));
        });
        seccion.querySelectorAll('[data-best-panel]').forEach(function (p) {
          p.hidden = p.dataset.bestPanel !== id;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matasana-prueba"] && !Shopify.designMode) return;
  try {
    

  // La cinta de plantas se mueve sola: la lista va duplicada, así que al llegar
  // a la mitad se vuelve al inicio y el giro no se nota. Se pausa al tocarla.
  function mtsPruebaCinta(cinta) {
    if (cinta.dataset.autoListo) return;
    cinta.dataset.autoListo = '1';
    if (cinta.dataset.auto !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var vel = parseFloat(cinta.dataset.vel || '40');
    var pausa = false, espera = 0, ultimo = null;
    // Acumulador propio: el navegador redondea scrollLeft y un avance de
    // menos de 1 px por cuadro se perdería en cada asignación.
    var pos = cinta.scrollLeft;
    cinta.addEventListener('scroll', function () {
      if (Math.abs(cinta.scrollLeft - pos) > 2) pos = cinta.scrollLeft;
    }, {passive: true});
    function reanudar() { espera = 1600; pausa = false; }
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      cinta.addEventListener(ev, function () { pausa = true; espera = 0; }, {passive: true});
    });
    ['pointerup', 'touchend', 'pointercancel'].forEach(function (ev) {
      cinta.addEventListener(ev, reanudar, {passive: true});
    });
    cinta.addEventListener('mouseenter', function () { pausa = true; espera = 0; });
    cinta.addEventListener('mouseleave', reanudar);
    function paso(t) {
      if (ultimo === null) ultimo = t;
      var dt = Math.min((t - ultimo) / 1000, 0.05);
      ultimo = t;
      if (espera > 0) { espera -= dt * 1000; if (espera <= 0) espera = 0; }
      var caja = cinta.getBoundingClientRect();
      var visible = caja.bottom > 0 && caja.top < window.innerHeight;
      var vuelta = cinta.scrollWidth / 2;
      if (!pausa && espera === 0 && visible && vuelta > 4) {
        pos += vel * dt;
        if (pos >= vuelta) pos -= vuelta;
        cinta.scrollLeft = pos;
      }
      requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }
  document.querySelectorAll('.mts-prueba__cinta--activa[data-mts-cinta]').forEach(mtsPruebaCinta);
  document.querySelectorAll('[data-ver-mas]').forEach(function (btn) {
    if (btn.dataset.listo) return;
    btn.dataset.listo = '1';
    var muro = btn.closest('section').querySelector('[data-muro]');
    if (!muro) return;
    var extras = muro.querySelectorAll('[data-extra]');
    var mas = btn.textContent.trim();
    var menos = btn.dataset.menos || 'Ver menos';
    btn.addEventListener('click', function () {
      var abierto = btn.getAttribute('aria-expanded') === 'true';
      extras.forEach(function (e) { e.hidden = abierto; });
      if (abierto) { muro.removeAttribute('data-abierto'); } else { muro.setAttribute('data-abierto', ''); }
      btn.setAttribute('aria-expanded', String(!abierto));
      btn.textContent = abierto ? mas : menos;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
